<template>
    <div id="app" class="d-flex flex-column h-100" :key="$root.keyApplication">
        <template v-if="ready">
            <transition name="website-fade" mode="out-in">
                <introduction v-if="!introduction" :phrases="phrases" @introductionComplete="introductionComplete()"></introduction>
                <website v-else></website>
            </transition>
        </template>
    </div>
</template>

<script>
import website from './components/website';
import introduction from './components/introduction';

export default {
    name: 'App',

    components: {
        "introduction": introduction,
        "website": website
    },

    data() {
        return {
            ready: false,
            introduction: false,
            phrases: []
        }
    },

    created() {
        axios.get('https://www.biswiss.ch/backend/api/phrases/' + this.$root.getLanguage(), this.$root.auth)
        .then(response => {
            this.phrases = response.data;
            this.ready = true;
        });
    },

    methods: {
        introductionComplete() {
            this.introduction = true;
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/App.vue